import React from 'react';
import '../pages/Page.css';

function Hero({ title, lead, actions, hint }) {
  return (
    <header className="page-hero">
      <h1 className="page-title">{title}</h1>
      {lead && <p className="page-lead">{lead}</p>}
      {actions && <div className="page-login-actions">{actions}</div>}
      {hint && <p className="page-login-hint text-muted small mt-2">{hint}</p>}
    </header>
  );
}

export default Hero;
